import {
    Box,
    Button,
    ButtonGroup,
    Card,
    CardContent, Checkbox,
    Container,
    FormControl, FormControlLabel, InputLabel,
    MenuItem,
    Select,
    TextField,
    Typography
} from "@mui/material";
import React, { useEffect, useState } from "react";
import UserAttributes from "../../interfaces/UserAttributes.interface";
import ErrorIcon from '@mui/icons-material/Error';
import {SSONewProfile} from "../../services/sso.service";

interface NewOIDCUserProps {
    acct: UserAttributes
    token: string
}

const OIDCNewUser: React.FC<NewOIDCUserProps> = ({ acct, token }) => {
    const [params, setParams] = React.useState<UserAttributes>(acct)
    const [confPassword, setConfPassword] = React.useState<string>("")
    const [DOBError, setDOBError] = React.useState<string>("")
    const [fNameError, setFNameError] = React.useState<string>("")
    const [lNameError, setLNameError] = React.useState<string>("")
    const [emailError, setEmailError] = React.useState<string>("")
    const [submitError, setSubmitError] = React.useState<string>("")

    
    const checkValidation = () => {
        let ret = true
        if (params?.DOB === "1900-01-01T00:00:00") {
            setDOBError("Please Input Your DOB!")
            ret = false
        }
        
        return ret
    }

    const submitUser = async () => {
        setSubmitError("")
        setDOBError("")
        setFNameError("")
        setLNameError("")
        setEmailError("")
        
        let p:any = { ...params }
        p.OldPassword = ""
        if (checkValidation()) {
            SSONewProfile(p, token).then((res) => {
                if (res && res.resp_type === "TOKEN") {
                    localStorage.setItem('user', res.token ? res.token : "")
                    window.location.href = "/"
                }
                
            })
           
        }
    }



    const CloseBox = () => {
        window.location.href = "/login"
    }

    return (
        <div className="min-w-screen min-h-screen bg-gray-800">
            <Container component="main">
                <Box
                    sx={{
                        marginTop: 0,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}

                >
                    <Card sx={{
                        marginTop: 15,
                        boxShadow: 25,
                    }} >
                        <CardContent>
                            <div className = "flex justify-center">
                                {/*<img src={logo} height="100" width="300" alt="" />*/}
                            </div>
                            <div className="grid grid-cols-3 mt-5">
                                <div className="w-full">
                                    <TextField
                                        size="small"
                                        InputLabelProps={{ 'shrink': true }}
                                        className="w-full"
                                        margin='none'
                                        label="User First Name"
                                        value={params?.FirstName}
                                        onChange={e => setParams({ ...params, FirstName: e.target.value })}
                                    />
                                </div>
                                <div className="w-full pr-10 pl-10">
                                    <TextField
                                        size="small"
                                        InputLabelProps={{ 'shrink': true }}
                                        className="w-full"
                                        margin='none'
                                        label="User Middle Initial"
                                        value={params?.MiddleName}
                                        onChange={e => setParams({ ...params, MiddleName: e.target.value })}
                                    />
                                </div>
                                <div className="w-full">
                                    <TextField
                                        size="small"
                                        InputLabelProps={{ 'shrink': true }}
                                        className="w-full"
                                        margin='none'
                                        label="User Last Name"
                                        value={params?.LastName}
                                        onChange={e => setParams({ ...params, LastName: e.target.value })}
                                    />
                                </div>
                            </div>

                            <div className="grid grid-cols-1 mt-5">
                                <TextField
                                    size="small"
                                    InputLabelProps={{ 'shrink': true }}
                                    className="w-full"
                                    margin='none'
                                    label="EMail Address"
                                    value={params?.EmailID}
                                    onChange={e => setParams({ ...params, EmailID: e.target.value })}
                                />
                            </div>

                            <div className="grid grid-cols-3 gap-y-5 mt-5">

                                <div className="w-full pr-2">
                                    <TextField
                                        size="small"
                                        InputLabelProps={{ 'shrink': true }}
                                        className="w-full"
                                        margin='none'
                                        label="Cell Phone #"
                                        value={params?.CellPhone}
                                        onChange={e => setParams({ ...params, CellPhone: e.target.value })}
                                    />
                                </div>

                                <div className="w-full pr-1 pl-1">
                                    <TextField
                                        size="small"
                                        InputLabelProps={{ 'shrink': true }}
                                        className="w-full"
                                        margin='none'
                                        label="Work Phone #"
                                        value={params?.WorkPhone}
                                        onChange={e => setParams({ ...params, WorkPhone: e.target.value })}
                                    />
                                </div>

                                <div className="w-full pl-2">
                                    <TextField
                                        size="small"
                                        type={"date"}
                                        InputLabelProps={{ 'shrink': true }}
                                        margin='none'
                                        className="w-full"
                                        label="DOB"
                                        color={DOBError.length > 0 ? "error" : "primary"}
                                        focused={DOBError.length > 0 ? true : undefined}
                                        autoFocus
                                        value={params?.DOB?.substring(0, 10)}
                                        onChange={e => setParams({ ...params, DOB: e.target.value })}
                                    />
                                    {DOBError.length > 0 ? <span style={{ color: "red", fontSize: 14 }}><ErrorIcon style={{ color: "red" }} fontSize='small' /> {DOBError}</span> : <></>}
                                </div>

                            </div>


                            <div className="mt-8 flex justify-center">
                                <ButtonGroup variant="outlined" size={"large"} color={"inherit"} >
                                    <Button onClick={submitUser} >Save</Button>
                                    <Button onClick={CloseBox}>CANCEL</Button>
                                </ButtonGroup>
                            </div>

                            {submitError.length > 0 ? <span style={{ color: "red", fontSize: 14 }}><ErrorIcon style={{ color: "red" }} fontSize='small' /> {submitError}</span> : <></>}
                        </CardContent>
                    </Card>
                </Box>

            </Container>
        </div>
    );
}

export default OIDCNewUser;
